// Import necessary dependencies from the Material-UI library
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

// Import custom styles for the component
import "./ChartType.css";

/**
 * ChartType component renders a toggle button group for selecting the chart type.
 * @param {string} chartType - The currently selected chart type.
 * @param {function} handleChartTypeChange - Function to handle chart type changes.
 * @returns {JSX.Element} - ChartType component.
 */
export default function ChartType({ chartType, handleChartTypeChange }) {
  return (
    <>
      {/* ToggleButtonGroup to select chart type */}
      <ToggleButtonGroup
        value={chartType}
        exclusive
        onChange={handleChartTypeChange}
        sx={{
          width: "100%",
          "& .Mui-selected": {
            color: "var(--theme-color-primary) !important",
          },
          borderColor: "var(--theme-color-primary)",
          border: "unset !important",
          "& .MuiToggleButtonGroup-grouped": {
            border: "1px solid !important",
            borderColor: "unset",
            color: "var(--theme-color-primary)",
          },
          "& .MuiToggleButton-standard": {
            color: "var(--theme-color-primary)",
          },
        }}
      >
        {/* ToggleButton for selecting "prices" chart type */}
        <ToggleButton sx={{ width: "33.3%" }} value="prices" className="toggle-btn">
          Price
        </ToggleButton>
        {/* ToggleButton for selecting "market_caps" chart type */}
        <ToggleButton sx={{ width: "33.3%" }} value="market_caps" className="toggle-btn">
          Market Cap
        </ToggleButton>
        {/* ToggleButton for selecting "total_volumes" chart type */}
        <ToggleButton sx={{ width: "33.3%" }} value="total_volumes" className="toggle-btn">
          Total Volume
        </ToggleButton>
      </ToggleButtonGroup>
    </>
  );
}
